import { render, staticRenderFns } from "./leaveAssign.vue?vue&type=template&id=e0dbfdb6&scoped=true"
import script from "./leaveAssign.vue?vue&type=script&lang=js"
export * from "./leaveAssign.vue?vue&type=script&lang=js"
import style0 from "./leaveAssign.vue?vue&type=style&index=0&id=e0dbfdb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dbfdb6",
  null
  
)

export default component.exports